import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import {
  Box,
  Stack,
  AppBar,
  Toolbar,
  FormControlLabel,
  Radio,
  Typography,
  Button,
} from '@mui/material';
// hooks
import useOffSetTop from '../../../hooks/useOffSetTop';
import useResponsive from '../../../hooks/useResponsive';
// utils
import cssStyles from '../../../utils/cssStyles';
// config
import { HEADER, NAVBAR } from '../../../config';
// components
import Logo from '../../../components/Logo';
import Iconify from '../../../components/Iconify';
import { IconButtonAnimate } from '../../../components/animate';
//
import AccountPopover from './AccountPopover';
import ThemeColorChanger from './ThemeColorChanger';
import ThemeModeSwitch from './ThemeModeSwitch';
import useAuth from '../../../hooks/useAuth';
import { useNavigate } from 'react-router';
import useToaster from '../../../hooks/useToaster';
import { toastTypes } from '../../../constants/keywords';
import { PATH_AUTH } from '../../../routes/paths';

// ----------------------------------------------------------------------

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout' && prop !== 'isAdmin',
})(({ isCollapse, isOffset, verticalLayout, isAdmin, theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  // ...(!isAdmin && {
  backgroundColor: '#140530',
  // }),
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  [theme.breakpoints.up('lg')]: {
    height: HEADER.DASHBOARD_DESKTOP_HEIGHT,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH + 1}px)`,
    ...(isCollapse && {
      width: `calc(100% - ${!isAdmin ? 0 : NAVBAR.DASHBOARD_COLLAPSE_WIDTH}px)`,
    }),
    ...(isOffset && {
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
    }),
    ...(verticalLayout && {
      width: '100%',
      height: HEADER.DASHBOARD_DESKTOP_OFFSET_HEIGHT,
      backgroundColor: theme.palette.background.default,
    }),
  },
}));

// ----------------------------------------------------------------------

DashboardHeader.propTypes = {
  onOpenSidebar: PropTypes.func,
  isCollapse: PropTypes.bool,
  verticalLayout: PropTypes.bool,
  isAdmin: PropTypes.bool,
};

export default function DashboardHeader({
  onOpenSidebar,
  isCollapse = false,
  verticalLayout = false,
  isAdmin = true,
}) {
  const isOffset = useOffSetTop(HEADER.DASHBOARD_DESKTOP_HEIGHT) && !verticalLayout;

  const isDesktop = useResponsive('up', 'lg');

  const navigate = useNavigate();
  const { toaster } = useToaster();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    try {
      const role = user?.role;
      await logout();

      navigate(PATH_AUTH.login, { replace: true });
      toaster('Logout Successfully', toastTypes.SUCCESS);
    } catch (error) {
      console.log('error :>> ', error);
      toaster('Unable to logout!', toastTypes.ERROR);
    }
  };

  return (
    <RootStyle
      isCollapse={isCollapse}
      isOffset={isOffset}
      verticalLayout={verticalLayout}
      isAdmin={isAdmin}
    >
      <Toolbar
        sx={{
          minHeight: '100% !important',
          px: { lg: 5 },
        }}
      >
        {!isAdmin && (
          <Logo
            // disabledLink={true}
            sx={{
              mr: 15.5,
              mt: 2,
              height: 150,
              width: 150,
            }}
          />
        )}
        {isDesktop && (
          <Typography
            sx={{ color: '#c5c1ca', fontSize: '1.3rem', marginTop: '0.8rem', fontWeight: 'bold' }}
          >
            Your Trusted Prop Trading Partner
          </Typography>
        )}
        {isDesktop && verticalLayout && <Logo sx={{ mr: 2.5 }} />}
        {!isDesktop && isAdmin && (
          <IconButtonAnimate onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Iconify icon="eva:menu-2-fill" />
          </IconButtonAnimate>
        )}
        <Box sx={{ flexGrow: 1 }} />
        <Stack direction="row" alignItems="center" spacing={{ xs: 0.5, sm: 1.5 }}>
          {/* <ThemeColorChanger /> */}
          {/* {isAdmin && <ThemeModeSwitch />} */}
          {isAdmin && <AccountPopover />}
          {!isAdmin && (
            <Button variant="outlined" onClick={handleLogout}>
              Logout
            </Button>
          )}
        </Stack>
      </Toolbar>
    </RootStyle>
  );
}

BoxMask.propTypes = {
  value: PropTypes.string,
};

export function BoxMask({ value }) {
  return (
    <FormControlLabel
      label=""
      value={value}
      control={<Radio sx={{ display: 'none' }} />}
      sx={{
        m: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        position: 'absolute',
      }}
    />
  );
}
